import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Card, Spin } from 'antd';
import { mFetch, MApiError } from '../mApi';
import { MPageTitle } from '../MobileApp';

interface Overview {
  totals: {
    pv: number;
    uv: number;
    sessions: number;
    avgDurationSec: number;
    bounceRate: number;
    downloads: number;
    downloadUv: number;
    leads: number;
  };
  trend: Array<{ date: string; pv: number; uv: number }>;
  days?: number;
}

function Stat({ label, value, suffix }: { label: string; value: number | string; suffix?: string }) {
  return (
    <Card size="small" style={{ background: '#141428', borderColor: '#26264a', flex: 1 }}>
      <div style={{ fontSize: 12, color: '#8a8aa3' }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>
        {value}
        {suffix ? <span style={{ fontSize: 12, color: '#8a8aa3', marginLeft: 2 }}>{suffix}</span> : null}
      </div>
    </Card>
  );
}

export default function MHome() {
  const [data, setData] = useState<Overview | null>(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    mFetch<Overview>('/admin/analytics/overview?days=7')
      .then(setData)
      .catch((e: MApiError) => setErr(e.hint ? `${e.message}（${e.hint}）` : e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <MPageTitle title="营销看板（近 7 天）" />
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
      ) : err ? (
        <div style={{ padding: 16 }}><Alert type="warning" showIcon title={err} /></div>
      ) : data ? (
        <div style={{ padding: '8px 16px' }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <Stat label="访客（UV）" value={data.totals.uv} />
            <Stat label="浏览量（PV）" value={data.totals.pv} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <Stat label="新增线索" value={data.totals.leads} />
            <Stat label="下载转化" value={data.totals.downloads} />
          </div>
          <Card size="small" style={{ background: '#141428', borderColor: '#26264a', marginTop: 8 }}>
            <div style={{ fontSize: 12, color: '#8a8aa3', marginBottom: 6 }}>会话 / 停留 / 跳出</div>
            <div style={{ fontSize: 14 }}>
              {data.totals.sessions} 次会话 · 平均停留 {data.totals.avgDurationSec}s · 跳出率 {data.totals.bounceRate}%
            </div>
          </Card>
          <Card size="small" style={{ background: '#141428', borderColor: '#26264a', marginTop: 8 }}>
            <div style={{ fontSize: 12, color: '#8a8aa3', marginBottom: 6 }}>趋势</div>
            {(data.trend || []).slice(-7).map((t) => (
              <div key={t.date} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '2px 0' }}>
                <span>{t.date}</span>
                <span style={{ color: '#8a8aa3' }}>UV {t.uv} · PV {t.pv}</span>
              </div>
            ))}
            {(!data.trend || data.trend.length === 0) && <div style={{ color: '#8a8aa3', fontSize: 13 }}>暂无数据</div>}
          </Card>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button data-testid="m-quick-leads" onClick={() => nav('/m/leads')} style={quickBtn}>看留言 →</button>
            <button data-testid="m-quick-articles" onClick={() => nav('/m/articles')} style={quickBtn}>发文章 →</button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

const quickBtn: React.CSSProperties = {
  flex: 1,
  padding: '10px 0',
  borderRadius: 8,
  border: '1px solid #2f6bff',
  background: 'rgba(78,158,255,.12)',
  color: '#4e9eff',
  fontSize: 14,
  cursor: 'pointer',
};
